import { put, call, takeLatest } from "redux-saga/effects";
import { get, isArray, noop, isFunction, merge } from "lodash-es";
import {
  fetch_mf_recommended_funds,
  fetch_nfo_recommendations,
  fetch_mf_payment_data,
  fetch_nfo_fund_details,
} from "../../apis/mf";
import { setError } from "../reducers/error";
import { setLoader } from "../reducers/loader";
import {
  fetchMfPaymentData,
  fetchMfRecommendations,
  resetMfRecommendations,
  updateMfRecommendations,
  fetchNfoFundsList,
  updateNfoFundsList,
  setSelectedNfoFund,
  fetchNfoFundDetails,
} from "../reducers/mfV2";
import { DEFAULT_EQUITY_DEBT_VALUES } from "../../constants/mf";
import { setPaymentDetails } from "../reducers/payment";

function* handleFetchMfRecommendations({ payload }) {
  const {
    params,
    sagaCallback = noop,
    dataToAppend = {},
    screen,
    initialize = false,
    token,
    Api,
    isFetchingData,
  } = payload;
  try {
    if (isFetchingData) {
      yield put(setLoader({ screen, isPageLoading: true }));
    } else {
      yield put(setLoader({ screen, isButtonLoading: true }));
    }
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const result = yield call(fetch_mf_recommended_funds, {
      Api,
      params,
      token,
    });
    let recommendation = {};
    if (isArray(result.recommendation)) {
      recommendation = {
        ...dataToAppend,
        ...result,
      };
    } else {
      recommendation = {
        ...dataToAppend,
        ...result.recommendation,
      };
    }
    recommendation.stockReturns =
      recommendation.expected_return_eq || DEFAULT_EQUITY_DEBT_VALUES.equity;
    recommendation.bondReturns =
      recommendation.expected_return_debt || DEFAULT_EQUITY_DEBT_VALUES.debt;

    if (initialize) {
      yield put(resetMfRecommendations(recommendation));
    } else {
      yield put(updateMfRecommendations(recommendation));
    }
    yield call(sagaCallback, result);
  } catch (error) {
    console.log("error in handleFetchMfRecommendations ", error);
    if (isFetchingData) {
      yield put(
        setError({ screen, isFetchFailed: true, message: error.message })
      );
    } else {
      yield put(
        setError({ screen, isUpdateFailed: true, message: error.message })
      );
    }
  } finally {
    yield put(
      setLoader({ screen, isButtonLoading: false, isPageLoading: false })
    );
  }
}

function* handleFetchMfPaymentData({ payload }) {
	const {
		Api,
		screen,
		body,
		token,
		sagaCallback = noop,
		handleError,
		platform,
		featureName,
		redirectPath,
	} = payload;
	try {
		yield put(setLoader({ screen, isButtonLoading: true }));
		yield put(
			setError({
				screen,
				isUpdateFailed: false,
				message: '',
			}),
		);
		const response = yield call(fetch_mf_payment_data, {
			Api,
			body,
			token,
			platform,
		});
		const paymentDetails = merge({}, response, {
			featureName,
			redirectPath,
		});
		yield put(setPaymentDetails(paymentDetails));
		yield call(sagaCallback, response);
	} catch (err) {
		console.log('error in handleFetchMfPaymentData ', err);
		if (isFunction(handleError)) {
			handleError(err);
		} else {
			yield put(
				setError({
					screen,
					isUpdateFailed: true,
					message: err.message,
					statusCode: err.statusCode,
				}),
			);
		}
	} finally {
		yield put(setLoader({ screen, isButtonLoading: false }));
	}
};

function* handleFetchNfoFundsList({ payload }) {
  const { Api, token, screen } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(setError({ screen, isFetchFailed: false, message: "" }));
    const result = yield call(fetch_nfo_recommendations, {
      Api,
      token,
    });
    const response = get(result, `recommendations`, {});
    yield put(updateNfoFundsList(response));
  } catch (error) {
    console.log("error in handleFetchNfoFundsList ", error);
    yield put(
      setError({ screen, isFetchFailed: true, message: error.message })
    );
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchNfoFundDetails({ payload }) {
  const { Api, isin, token, screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(setError({ screen, isFetchFailed: false, message: "" }));
    const result = yield call(fetch_nfo_fund_details, {
      Api,
      token,
      isin,
    });
    const nfoFund = get(result, `nfo`, {});
    yield put(setSelectedNfoFund(nfoFund));
    yield call(sagaCallback, [nfoFund]);
  } catch (error) {
    console.log("error in handleFetchNfoFundDetails ", error);
    yield put(
      setError({ screen, isFetchFailed: true, message: error.message })
    );
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

export default function* sagaFetchMfData() {
  yield takeLatest(
    fetchMfRecommendations.toString(),
    handleFetchMfRecommendations
  );
  yield takeLatest(fetchMfPaymentData.toString(), handleFetchMfPaymentData);
  yield takeLatest(fetchNfoFundsList.toString(), handleFetchNfoFundsList);
  yield takeLatest(fetchNfoFundDetails.toString(), handleFetchNfoFundDetails);
}
